import { useRouter } from 'next/router';
import { useWindowAdapter } from 'root/src/client/v2/queryParams/adapters/window.adapter';
export const WindowSSRAdapter = ({ children }) => {
    const nextAdapter = useNextAdapter();
    if (typeof window === 'undefined') {
        return children(nextAdapter);
    }
    const windowAdapter = useWindowAdapter();
    return children(windowAdapter);
};
function useNextAdapter() {
    const { query } = useRouter();
    return {
        replace() {
            return undefined;
        },
        push() {
            return undefined;
        },
        get location() {
            const params = new URLSearchParams(query);
            const search = params.toString();
            return { search };
        },
    };
}
